import { AppstoreOutlined } from '@ant-design/icons';

export const EmptyState = (): JSX.Element => {
  return (
    <div className="text-center p-[clamp(40px,10vw,80px)_clamp(16px,5vw,32px)] bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl border border-dashed border-gray-300">
      <AppstoreOutlined className="text-[clamp(48px,15vw,72px)] text-gray-400 mb-6" />
      <p className="text-[clamp(16px,4vw,18px)] font-semibold text-gray-600 mb-2">No platforms available</p>
      <p className="text-[clamp(13px,3vw,14px)] text-gray-500">Contact your administrator for access</p>
    </div>
  );
};
